module.exports = __webpack_public_path__ + "img/93.1.8f2c3cc7.jpg";